import angular from 'angular';

BasketService.$inject = ['$resource', 'appconfig'];

function BasketService($resource, appconfig) {
    return $resource(appconfig.apiEndpoint + "/basket/:id", {id: '@id'}, {
        count: {
            method: 'GET',
            params: {
                id: 'count'
            },
            transformResponse: function(data, headersGetter, status) {
                var jsonData = angular.fromJson(data);
                if (jsonData.success) {
                    return { content: jsonData.data };
                } else {
                    return { content: -1 };
                }
            }
        }
    });

}

export default angular.module('basket.service', [])
    .factory('BasketService', BasketService)
    .name;
